<!-- TABS -->
<eif-custom-tabs
	[tabs]="tabs"
	[activeTabId]="activeTabId"
	[actions]="tabActions"
	[class]="'mt-3 mb-4'">
	<div class="dashboard-tab-content">
		<div>
			<!-- CURRENCIES -->
			@if (orderedCurrencies.length > 1) {
				<eif-custom-segmented-control
					[options]="currencyOptions"
					[value]="selectedCurrency"
					[class]="'mb-2'"
					[size]="'small'"
					[variant]="'outlined'"
					(valueChange)="clickedCurrency($event.toString())">
				</eif-custom-segmented-control>
			}
			<div class="dashboard-cards-wrap">
				<app-dashboard-metric-card
					card="confirming.contractedAmount"
					[value]="contractedAmount | currencyLocale: selectedCurrency"
					[loading]="loadingContractedAmount" />
				<app-dashboard-metric-card
					card="confirming.contractsAvailableAmount"
					[value]="contractsAvailableAmount | currencyLocale: selectedCurrency"
					[sublabel]="((contractsAvailableAmountRatio | numberLocale: '1.2-2') ?? '0') + '%'"
					[loading]="loadingContractsAvailableAmount" />
				<app-dashboard-metric-card
					card="confirming.notPaidDocuments"
					[value]="notPaidDocuments | currencyLocale: selectedCurrency"
					[loading]="loadingNotPaidDocuments" />
				<app-dashboard-metric-card
					card="confirming.currentFundingRequestsAmount"
					[value]="currentFundingRequestsAmount | currencyLocale: selectedCurrency"
					[loading]="loadingCurrentFundingRequestsAmount" />
				<app-dashboard-metric-card
					card="confirming.companies"
					[value]="loggedUser?.Companies.length" />
				<app-dashboard-metric-card
					card="confirming.suppliersActiveConnections"
					[value]="suppliersActiveConnections"
					[loading]="loadingSuppliersActiveConnections" />
				<app-dashboard-metric-card
					card="confirming.pendingApprovalDocumentsAmount"
					[value]="confirmingPendingApprovalDocumentsAmount"
					[loading]="loadingConfirmingPendingApprovalDocumentsAmount"
					[hasAction]="true"
					(action)="navigateToFilesIntegration(FileStatus.PendingBuyerApproval)" />
			</div>
		</div>

		<!-- Charts area -->
		<div class="dashboard-chart-wrapper mt-4">
			<div class="is-label">
				{{ 'dashboard-supplier.documentForecast' | translate }}
			</div>
			@if (documentForecastChart.Results && documentForecastChart.Results.length > 0) {
				<app-document-forecast-chart
					[chart]="documentForecastChart"
					[currency]="selectedCurrency" />
			}
		</div>
	</div>
</eif-custom-tabs>
